<div class="termsDetailsCon p-3">
  <div class="quoteInfo" fxLayout="column">
    <span><b>Quote Number</b>: {{quoteData.quoteNumber}}</span>
<!--    <span><b>Start Date</b>: {{quoteData.startDate | date: "MM/dd/YYYY"}}</span>-->
<!--    <span><b>Terms (Month)</b>: {{quoteData.termsLabel}}</span>-->
<!--    <span><b>Broker Margin ($/Mwh)</b>: {{quoteData.brokerMargin}}</span>-->
  </div>
  <form [formGroup]="termForm" (ngSubmit)="submitTermDetails()" fxLayout="column" class="mt-3">
    <mat-form-field appearance="fill">
      <mat-label>New Start Date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="startDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>New Terms</mat-label>
      <input matInput formControlName="terms">
    </mat-form-field>
    <div class="error-text" *ngIf="termVal.errors?.patternInValid">Terms should be comma separated numbers</div>
    <div class="error-text" *ngIf="termVal.errors?.lengthInValid">Max terms will be 7</div>
    <div class="error-text" *ngIf="termVal.errors?.termPjmInvalid">Term Months Exceeds the limit (PJM terms should be on or before 62)</div>
    <div class="error-text" *ngIf="termVal.errors?.termErcotInvalid">Term Months Exceeds the limit (ERCOT terms should be on or before 50)</div>
    <mat-form-field appearance="fill">
      <mat-label>New Broker Margin</mat-label>
      <input matInput formControlName="margin" type="number">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="userComment" rows="3"></textarea>
    </mat-form-field>
    <div fxLayout="row">
      <button type="submit" mat-raised-button color="primary" [disabled]="!termForm.valid">Submit</button>
      <span class="p-2"></span>
      <button type="button" mat-raised-button color="primary" (click)="closeActiveTermsDialog($event)">Cancel</button>
    </div>
  </form>
</div>
